import type React from 'react';

interface ModalScaffoldProps {
  /** When true, the scaffold fills the screen on top of everything else. */
  open: boolean;
  children: React.ReactNode;
  className?: string;
  /** Click on the dimmed area outside the modal card. */
  onBackdropClick?: () => void;
  backdropAriaLabel?: string;
}

/**
 * Presentational overlay that renders its children on top of the app when `open`.
 * Structure/styling only — dimmed full-viewport backdrop shell (card chrome is owned by the consumer).
 */
const ModalScaffold = ({
  open,
  children,
  className = '',
  onBackdropClick,
  backdropAriaLabel = 'Close',
}: ModalScaffoldProps) => {
  if (!open) {
    return null;
  }

  return (
    <div className={`modal-scaffold ${className}`.trim()} role="presentation">
      {onBackdropClick && (
        <button
          type="button"
          className="modal-scaffold__backdrop"
          aria-label={backdropAriaLabel}
          onClick={onBackdropClick}
        />
      )}
      <div className="modal-scaffold__surface">{children}</div>
    </div>
  );
};

export default ModalScaffold;
